module.exports = __webpack_public_path__ + "static/media/answers_4.1d230b3d.jpg";